import { render, staticRenderFns } from "./configuration.vue?vue&type=template&id=f33bbea8&scoped=true"
import script from "./configuration.vue?vue&type=script&lang=js"
export * from "./configuration.vue?vue&type=script&lang=js"
import style0 from "./configuration.vue?vue&type=style&index=0&id=f33bbea8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f33bbea8",
  null
  
)

export default component.exports